import * as React from "react";
import { SVGProps } from "react";
export const SvgAddAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 3 11 9 17 9 17 11 11 11 11 17 9 17 9 11 3 11 3 9 9 9 9 3z"
      stroke="none"
      strokeWidth={1}
      fillRule="evenodd"
    />
  </svg>
);
